module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Devices/LTE2-32ad8b8d90a78c8b1893d1daf42bc055.svg";